import React, { useState } from 'react';
import InterviewerList from 'components/InterviewerList';
import Button from 'components/Button'

const Form = (props) => {

  const [name, setName] = useState(props.name || '');
  const [interviewer, setInterviewer] = useState(props.interviewer || null);
  const [error, setError] = useState("");

  /**
   * It resets the form. 
   * This will run when user click cancels
   */
  const reset = () => {
    setName('');
    setInterviewer(null);
  }

  /**
   * Click cancel functionality
   */
  const cancel = () => {
    reset();
    props.onCancel();
  }

  /**
   * It validates if the student or interviewer
   * is present in the form or not.
   *
   * @return {*} 
   */
  const validate = () =>{
    if (name === ''){
      setError('Student name cannot be blank');
      return;
    }
    if(interviewer === null) {
      setError('Please select the interviewer');
      return;
    }
    setError('')
    props.onSave(name,interviewer)
  }

  return (
    <main className='appointment__card appointment__card--create'>
      <section className='appointment__card-left'>
        <form autoComplete='off'
          onSubmit={event => event.preventDefault()}
        >
          <input
            className='appointment__create-input text--semi-bold'
            name={name}
            type='text'
            placeholder='Enter Student Name'
            onChange={(event) => setName(event.target.value)}
            value={name}
            data-testid="student-name-input"
          />
        </form>
        <section className="appointment__validation">{error}</section>
        <InterviewerList interviewers={props.interviewers} value={interviewer} onChange={setInterviewer} />
      </section>
      <section className='appointment__card-right'>
        <section className='appointment__actions'>
          <Button danger onClick={cancel}>Cancel</Button>
          <Button confirm onClick={validate}>Save</Button>
        </section>
      </section>
    </main>
  );
}

export default Form;